var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"institucional"}},[(_vm.isMobile)?_c('img',{staticClass:"org",attrs:{"src":require("../assets/organizacionMob.jpg"),"alt":"organizacion"}}):_c('img',{staticClass:"org",attrs:{"src":require("../assets/organizacion.jpg"),"alt":"organizacion"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }